import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowCirclePath = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 12c0 5.51 4.49 10 10 10s10-4.49 10-10c0-.55-.45-1-1-1s-1 .45-1 1c0 4.41-3.59 8-8 8s-8-3.59-8-8 3.59-8 8-8a8 8 0 0 1 6.03 2.74h-2.72c-.55 0-1 .45-1 1s.45 1 1 1h4.74c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1.907A10 10 0 0 0 12 2C6.49 2 2 6.49 2 12"
    />
  </svg>
);
export default SvgArrowCirclePath;
